import { useState } from "react";
import "./styles.css";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import FreeExpiredGuard from "../../components/FreeExpiredGuard";
import Menu from "../../components/Menu";
import NavbarDashboard from "../../components/NavbarDashboard";
import Composer from "./components/Composer";
import MessagesPane from "./components/MessagesPane";
import Sidebar from "./components/Sidebar";
import { useDeleteChat } from "./hooks/useChatData";

const queryClient = new QueryClient();

function Main() {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("user")));
  const [selectedChatId, setSelectedChatId] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const deleteChat = useDeleteChat();

  async function handleDeleted(id) {
    // TODO: adjust delete chat. Add elegant modal.

    if (!window.confirm("Excluir esta conversa?")) return;
    try {
      await deleteChat.mutateAsync(id);
      setSelectedChatId(null);
      await queryClient.invalidateQueries({ queryKey: ["chats"] });
    } catch (error) {
      console.error(error);
    }
  }

  function toggleSidebar() {
    setIsSidebarOpen(!isSidebarOpen);
  }

  function closeSidebar() {
    setIsSidebarOpen(false);
  }

  return (
    <FreeExpiredGuard>
      <QueryClientProvider client={queryClient}>
        <NavbarDashboard />
        <section className="home">
        <Menu />

        {/* Overlay escuro */}
        <div
          className={`ia-sidebar-overlay ${isSidebarOpen ? "is-visible" : ""}`}
          onClick={closeSidebar}
        />

        <div className="ia-layout">
          <Sidebar
            selectedId={selectedChatId}
            onSelect={(id) => {
              setSelectedChatId(id);
              closeSidebar();
            }}
            onDelete={handleDeleted}
            isOpen={isSidebarOpen}
          />
          <div className="ia-main">
            <div className="ia-main__messages">
              <MessagesPane chatId={selectedChatId} />
            </div>
            <Composer
              selectedChatId={selectedChatId}
              onChatCreated={setSelectedChatId}
              isSidebarOpen={isSidebarOpen}
              onToggleSidebar={toggleSidebar}
            />
          </div>
        </div>
      </section>
      </QueryClientProvider>
    </FreeExpiredGuard>
  );
}

export default Main;
